export const services = [
  {
    id: 1,
    title: "Trademark Registration",
    description: "File your federal trademark application with the USPTO. Our attorneys handle the full process from search to approval, giving your brand exclusive legal protection nationwide.",
    icon: "Shield",
    path: "/services/trademark-registration"
  },
  {
    id: 2,
    title: "Copyright Registration",
    description: "Secure ownership of your creative works, digital assets, and original content. Professional copyright filing with the US Copyright Office, backed by attorney review.",
    icon: "FileText",
    path: "/services/copyright-registration"
  },
  {
    id: 3,
    title: "Company Formation",
    description: "Form your LLC or corporation with proper legal structure. We handle state filings, operating agreements, and EIN registration so you launch with confidence.",
    icon: "Building2",
    path: "/services/company-formation"
  },
  {
    id: 4,
    title: "Trademark Search",
    description: "Before you file, know where you stand. Our deep search across USPTO records, state databases, and common-law sources uncovers conflicts early and saves you money.",
    icon: "Search",
    path: "/services/trademark-search"
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    description: "Enroll in Amazon Brand Registry with a qualifying trademark. Unlock A+ Content, Sponsored Brands, and seller IP tools that give your listings a competitive edge.",
    icon: "ShoppingBag",
    path: "/services/amazon-brand-registry"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Essentials",
    price: "$45",
    federal: "+ Federal Filing Fee",
    recommended: false,
    features: [
      "Case Review & Consultation",
      "USPTO Application Filing",
      "Basic Trademark Search",
      "State E-Filing Included",
      "Email Support"
    ],
    note: "(Govt. filing fee not included)",
    buttonText: "Start with Essentials"
  },
  {
    id: 2,
    name: "Enhanced",
    price: "$149",
    federal: "+ Federal Filing Fee",
    recommended: false,
    features: [
      "Everything in Essentials",
      "Direct Hit Search Report",
      "Trademark Alert Monitoring",
      "Refusal Risk Assessment",
      "Phone & Email Support"
    ],
    note: "(Govt. filing fee not included)",
    buttonText: "Go Enhanced"
  },
  {
    id: 3,
    name: "Deluxe",
    price: "$299",
    federal: "+ Federal Filing Fee",
    recommended: true,
    features: [
      "Everything in Enhanced",
      "Comprehensive Monitoring",
      "Complete Documentation Pack",
      "Digital Case File Access",
      "Dedicated Case Manager",
      "Priority Processing"
    ],
    note: "(Govt. filing fee not included)",
    buttonText: "Choose Deluxe"
  },
  {
    id: 4,
    name: "Platinum",
    price: "$349",
    federal: "+ Federal Filing Fee",
    recommended: false,
    features: [
      "Everything in Deluxe",
      "Full Comprehensive Search",
      "High Priority Filing",
      "Cease & Desist Letter",
      "Dedicated Attorney",
      "24/7 Premium Support"
    ],
    note: "(Govt. filing fee not included)",
    buttonText: "Go Platinum"
  }
];

export const uspsSupport = [
  { id: 1, icon: "Shield", title: "Bank-Level Security", description: "Every application filed under strict confidentiality with encrypted data handling." },
  { id: 2, icon: "Clock", title: "Expedited Filing", description: "Priority processing options available to get your trademark submitted faster." },
  { id: 3, icon: "Award", title: "Seasoned Attorneys", description: "Trademark lawyers with deep USPTO filing experience across every major industry." },
  { id: 4, icon: "DollarSign", title: "No Hidden Fees", description: "What you see is what you pay. Transparent packages starting at just $45." },
  { id: 5, icon: "CheckCircle", title: "Proven Results", description: "A strong track record of successful registrations for businesses of all sizes." },
  { id: 6, icon: "Headphones", title: "On-Demand Support", description: "Reach our team whenever you have questions. We respond, not auto-reply." },
  { id: 7, icon: "FileText", title: "Full Paper Trail", description: "Real-time status updates and complete documentation at your fingertips." },
  { id: 8, icon: "Users", title: "US-Wide Coverage", description: "Federal trademark protection in all 50 states, plus territories." }
];

export const uspsProfessional = [
  { id: 1, icon: "Target", title: "Pinpoint Filing", description: "We select the right trademark classes and prepare accurate applications to minimize rejections." },
  { id: 2, icon: "Search", title: "Multi-Layer Search", description: "Searches across federal, state, and common-law records to uncover conflicts you would miss." },
  { id: 3, icon: "Bell", title: "Active Monitoring", description: "We keep watch after registration, alerting you to new filings that could threaten your mark." },
  { id: 4, icon: "FileCheck", title: "Office Action Defense", description: "If the USPTO objects, our attorneys draft persuasive legal responses to push your application forward." },
  { id: 5, icon: "Globe", title: "Coast-to-Coast Protection", description: "A single federal registration protects your brand across all 50 states." },
  { id: 6, icon: "Zap", title: "Brand Registry Ready", description: "We prepare your trademark to meet Amazon Brand Registry requirements from day one." },
  { id: 7, icon: "Lock", title: "Regulatory Compliance", description: "Every filing follows current USPTO rules, so your registration stands on solid legal ground." },
  { id: 8, icon: "TrendingUp", title: "Growth Strategy", description: "Strategic advice on expanding your trademark portfolio as your business scales." }
];

export const whyChooseUs = [
  {
    id: 1,
    icon: "Award",
    title: "Deep Legal Expertise",
    description: "Our trademark attorneys have guided thousands of businesses through USPTO registration. From name searches to office action responses, we know what works and what does not."
  },
  {
    id: 2,
    icon: "DollarSign",
    title: "Upfront, Honest Pricing",
    description: "No surprise invoices. No upsells. Our packages are priced clearly from $45, so you know the cost before you start. Government filing fees are always listed separately."
  },
  {
    id: 3,
    icon: "Headphones",
    title: "A Real Person, Every Step",
    description: "You get a dedicated case manager who knows your file inside out. Real-time updates, direct communication, and answers when you need them. No ticket queues."
  }
];

export const workProcess = [
  {
    id: 1,
    step: "01",
    title: "Tell Us About Your Brand",
    description: "Share your brand name, logo, or slogan with our team. We assess your needs and build a filing strategy tailored to your business and target market."
  },
  {
    id: 2,
    step: "02",
    title: "Search & Strategy",
    description: "We run a deep trademark search through USPTO records, state filings, and common-law databases. You receive a clear report with expert recommendations."
  },
  {
    id: 3,
    step: "03",
    title: "File & Protect",
    description: "We submit your application, handle any USPTO correspondence, and track your case through every milestone until your trademark is officially registered."
  }
];

export const testimonials = [
  { id: 1, name: "Sarah Mitchell", role: "E-commerce Founder", service: "Trademark Registration", content: "I was nervous about the process, but this team made it painless. My trademark was approved without a single office action. The Deluxe package gave me everything I needed and more.", rating: 5 },
  { id: 2, name: "Michael Chen", role: "Tech Startup CEO", service: "Trademark Search", content: "Their search report caught a conflict I would have walked right into. That alone saved my company from a rebrand six months in. Worth every cent of the investment.", rating: 5 },
  { id: 3, name: "Jennifer Rodriguez", role: "Amazon Seller", service: "Amazon Brand Registry", content: "Went from zero brand presence to full A+ Content and Sponsored Brands in weeks. The team understood exactly what Amazon requires and delivered fast.", rating: 5 },
  { id: 4, name: "David Thompson", role: "Product Designer", service: "Copyright Registration", content: "I needed my product designs protected before a trade show. They filed my copyright in days and handled all the paperwork. Totally professional.", rating: 5 },
  { id: 5, name: "Amanda Stevens", role: "Restaurant Owner", service: "Company Formation", content: "LLC formation and trademark registration bundled together saved me time and money. One team, one process, zero confusion. Exactly what a busy founder needs.", rating: 5 },
  { id: 6, name: "Robert Wilson", role: "Online Retailer", service: "Trademark Registration", content: "The Essentials package was perfect for my budget and my first trademark is now registered. Clean process, responsive team, no surprises.", rating: 5 },
  { id: 7, name: "Emily Parker", role: "Fashion Brand Owner", service: "Trademark Registration", content: "The Platinum plan gave me everything: comprehensive search, priority filing, and a cease and desist letter when a copycat showed up. Best money I have spent.", rating: 5 },
  { id: 8, name: "James Anderson", role: "SaaS Founder", service: "Company Formation", content: "They set up my Delaware LLC and filed my trademark simultaneously. The coordination was seamless and the team kept me updated at every step.", rating: 5 },
  { id: 9, name: "Lisa Martinez", role: "Content Creator", service: "Copyright Registration", content: "As a YouTuber, protecting my content is non-negotiable. They made the copyright process dead simple and now my work is legally protected.", rating: 5 },
  { id: 10, name: "Kevin Brown", role: "Manufacturing CEO", service: "Trademark Search", content: "The search report was incredibly thorough. They found issues I did not expect and gave me a clear action plan. Saved me from a big legal headache down the road.", rating: 5 }
];

export const faqs = [
  { id: 1, question: "What exactly is trademark registration and why does it matter?", answer: "Trademark registration is the legal process of securing exclusive rights to a brand name, logo, or slogan with the USPTO. It gives you nationwide protection, prevents competitors from using confusingly similar marks, qualifies you for the \u00AE symbol, and is mandatory for Amazon Brand Registry enrollment." },
  { id: 2, question: "How long does the trademark registration process take from start to finish?", answer: "Typical timeline is 6 to 12 months. USPTO examination begins within 3 to 4 months of filing. If approved, your mark enters a 30-day opposition window before final registration. Our team handles any office actions quickly to prevent unnecessary delays." },
  { id: 3, question: "What is included in the $45 Essentials package?", answer: "The Essentials package covers a professional case review, USPTO application filing, basic trademark search, state e-filing, and email support. Government filing fees ($250 to $350 per class) are separate and paid directly to the USPTO." },
  { id: 4, question: "How do the four pricing tiers compare?", answer: "Essentials ($45) covers core filing. Enhanced ($149) adds direct hit search, monitoring alerts, and risk assessment. Deluxe ($299), our most popular, includes comprehensive monitoring, full documentation, and a dedicated case manager. Platinum ($349) adds full search reports, priority filing, attorney access, and cease and desist support." },
  { id: 5, question: "Should I run a trademark search before filing?", answer: "Absolutely. A comprehensive search uncovers conflicting marks in USPTO records, state databases, common law usage, and domain names. Filing without a search is a gamble that can waste your filing fees and months of waiting time." },
  { id: 6, question: "Can you handle Amazon Brand Registry enrollment?", answer: "Yes. We guide you through every step, ensuring your trademark meets Amazon requirements. Once enrolled, you gain access to A+ Content, Sponsored Brands advertising, and enhanced IP protection tools for your seller account." },
  { id: 7, question: "What happens if the USPTO rejects my application?", answer: "If the USPTO issues an office action, our attorneys analyze the objection, develop legal arguments, and file a formal response within the required deadline. Our experience with these responses gives clients a strong path forward." },
  { id: 8, question: "What is the difference between a trademark and a copyright?", answer: "Trademarks protect brand identifiers like names, logos, and slogans that distinguish your products. Copyrights protect original creative works like product descriptions, images, videos, and written content. Amazon sellers typically need a trademark for Brand Registry and copyrights for listing protection." },
  { id: 9, question: "Do I need to form a company before registering a trademark?", answer: "No. You can file as an individual. However, forming an LLC or Corporation first offers personal liability protection and professional credibility. For Amazon sellers planning to scale, we recommend company formation before trademark filing. We offer bundles." },
  { id: 10, question: "What are the government filing fees?", answer: "USPTO filing fees range from $250 to $350 per trademark class and are paid directly to the government, separate from our service fees. We help you identify the correct classes and guide you through the government payment process." }
];
